import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from "react-toastify";
import { clearErrorLogs } from '../../store/actions/Error/ErrorActions';
import ContentPasteIcon from '@mui/icons-material/ContentPaste';
import CloseIcon from '@mui/icons-material/Close';
import './errorLogger.css';

function ErrorLogsDialog() {
  const { errorLogs, isError, errorData } = useSelector(state => state.errorData)
  const dispatch = useDispatch()

  const handleCopyLogs = (data) => {
    toast.dismiss();
    navigator.clipboard.writeText(data)
    toast.success('Logs copied successfully');
  };

  const onClose = () => {
    dispatch(clearErrorLogs())
  };

  console.log({ errorLogs, errorData, message: 'Logs err' })

  if (!isError) return null;

  const LogContainer = ({ logs }) => {
    return (
      <div className='errorContainer'>
        <textarea
          value={logs}
          readOnly
          className='errorLogs'
        />
        <div className='copyBtn'>
          <IconButton onClick={() => handleCopyLogs(logs)} >
            <ContentPasteIcon fontSize='small' />
          </IconButton>
        </div>
      </div>
    )
  }

  return (
    <Dialog open={isError} onClose={onClose} fullWidth maxWidth="sm" sx={{ p: 3 }}>

      <DialogTitle>
        Error Logs
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DialogContentText sx={{ mb: 1 }}>
          View and copy the error logs and additional data below.
        </DialogContentText>

        <LogContainer logs={errorLogs} />

        {errorData && (
          <>
            <p>Additional Error Data</p>
            <LogContainer logs={errorData} />
          </>
        )}

      </DialogContent>

    </Dialog>
  );
}

export default ErrorLogsDialog;
